import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminModalFooter',
  props: {
    align: { default: "end" },
    variant: { default: "muted" },
    roundedBottom: { type: Boolean, default: false }
  },
  setup(__props: any) {



const alignClass = {
  end: "justify-end",
  start: "justify-start",
  between: "justify-between",
  stretch: "justify-stretch flex-col-reverse sm:flex-row sm:justify-end gap-2",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["px-5 sm:px-6 py-4 flex flex-wrap gap-2 sm:gap-3 min-w-0", [
      alignClass[__props.align],
      __props.variant === 'muted'
        ? 'bg-slate-50 border-t border-slate-200'
        : 'border-t border-slate-100',
      __props.roundedBottom ? 'rounded-b-2xl' : '',
    ]])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})